<template>
    <v-main>
        <div class="pt-6 pb-6 pr-3 pl-3">
            <v-container>
                <v-form>
                    <div>
                        <legend class="mb-3">Faça o upload da planilha da carga AR</legend>

                        <FilePicker
                            v-show="uploadCargaARRequestStatus === RequestStatusEnum.IDLE"
                            ref="filePicker"
                            @onReset="resetted"
                            @onFileChange="fileChanged"
                            :acceptedFileTypes="fileTypes"
                        />
                    </div>
                    <Loader
                        mode="overlay"
                        v-if="uploadCargaARRequestStatus === RequestStatusEnum.START"
                        class="text-center mt-3"
                    />

                    <section
                        class="section-response"
                        v-if="uploadCargaARRequestStatus.type === RequestStatusEnum.ERROR"
                    >
                        <textarea
                            class="custom-textarea mt-6"
                            v-model="uploadCargaARRequestStatus.message"
                        >
                        </textarea>
                    </section>

                    <footer align="right" class="mt-6">
                        <v-btn
                            v-show="uploadCargaARRequestStatus.type === RequestStatusEnum.ERROR"
                            @click="reset"
                            color="secondary"
                            depressed
                            class="v-btn-responsive"
                            >Refazer</v-btn
                        >

                        <v-btn
                            v-show="uploadCargaARRequestStatus.type !== RequestStatusEnum.ERROR"
                            :disabled="
                                !selectedFile ||
                                    uploadCargaARRequestStatus === RequestStatusEnum.START
                            "
                            @click="uploadFile"
                            color="secondary"
                            depressed
                            class="v-btn-responsive"
                        >
                            Confirmar
                        </v-btn>
                    </footer>
                </v-form>
            </v-container>
        </div>
    </v-main>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
//import { notification } from '@/helpers/notification';
import { RequestStatusEnum } from '@/helpers/consts';
import FilePicker from '@/components/base/FilePicker/FilePicker';
import Loader from '@/components/base/Loader';

export default {
    components: {
        FilePicker,
        Loader,
    },
    data() {
        return {
            uploadedFiles: [],
            uploadError: null,
            fileCount: null,
            selectedFile: null,
            RequestStatusEnum,
            fileTypes:
                '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
        };
    },
    methods: {
        ...mapActions('importacoes', {
            uploadCargaARRequest: 'uploadCargaARRequest',
            dismissUploadCargaARRequestStatus: 'dismissUploadCargaARRequestStatus',
        }),
        uploadFile() {
            const formData = new FormData();
            formData.append('file', this.selectedFile, this.selectedFile.name);
            this.uploadCargaARRequest({ idProduct: this.selectedProduct.id, formData });
        },
        reset() {
            this.dismissUploadCargaARRequestStatus();
            this.selectedFile = null;
        },
        resetted() {
            this.selectedFile = null;
        },
        fileChanged(file) {
            this.selectedFile = file;
        },
    },
    computed: {
        ...mapGetters('importacoes', {
            uploadCargaARRequestStatus: 'uploadCargaARRequestStatus',
            selectedProduct: 'selectedProduct',
        }),
    },
    watch: {
        uploadCargaARRequestStatus(newValue) {
            if (newValue === RequestStatusEnum.SUCCESS) {
                // notification(this.$dialog.notify.success, 'Carga de AR efetuada com sucesso');
                this.$dialog.notify.success('Carga de AR efetuada com sucesso', {
                    position: 'top-right',
                });
                if (this.$refs.filePicker.reset) this.$refs.filePicker.reset();
                this.reset();
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.v-form {
    max-width: 800px;
    margin: 0 auto;
}
</style>
